import { Link, Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar, isSidebarItemActive } from './Sidebar';
import { BookOpen, Users, UserRound, Dumbbell, CalendarDays, LayoutDashboard, Tags } from 'lucide-react';
import { cn } from '@/utils/cn';
import { PublicFooter } from '@/components/public/PublicFooter';

const sidebarItems = [
  { label: 'Overview', path: '/admin', icon: LayoutDashboard, exact: true },
  { label: 'Course List', path: '/admin/courses', icon: BookOpen },
  { label: 'Sports', path: '/admin/sports', icon: Dumbbell },
  { label: 'Events', path: '/admin/events', icon: CalendarDays },
  { label: 'Categories', path: '/admin/categories', icon: Tags },
  { label: 'Tutors', path: '/admin/tutors', icon: UserRound },
  { label: 'User Registrations', path: '/admin/registrations', icon: Users },
];

export const AdminLayout = () => {
  const location = useLocation();

  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <div className="flex h-full min-h-0 flex-col overflow-hidden">
          <div className="sticky top-0 z-30 border-b border-slate-200 bg-white md:hidden">
            <nav className="flex items-center gap-2 overflow-x-auto px-4 py-3 scrollbar-thin">
              {sidebarItems.map((item) => {
                const Icon = item.icon;
                const isActive = isSidebarItemActive(location.pathname, item);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={cn(
                      'inline-flex items-center gap-2 whitespace-nowrap rounded-lg border px-3 py-2 text-sm font-semibold transition',
                      isActive
                        ? 'border-[rgb(var(--accent-solid))/0.30] bg-[rgb(var(--accent-solid))/0.10] text-[rgb(var(--accent-solid))]'
                        : 'border-slate-200 text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="flex min-h-0 flex-1">
            <Sidebar items={sidebarItems} />
            <div className="flex min-h-0 flex-1 flex-col">
              <section className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8">
                <Outlet />
              </section>
              <PublicFooter />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
